export default __webpack_public_path__ + "static/media/background.812b1d9d.svg";